import React, { useState, useEffect } from "react";
import {
    FormControl,
    Select,
    MenuItem,
    InputLabel,
    Stack,
    TextField
} from "@mui/material";
import { useSelector } from "react-redux";
import { setDeepValue } from "../../utils/utils";

const MapFilters = ({ filters, setFilters }) => {

    const [patrolStatuses, setPatrolStatuses] = useState([]);
    const [taskStatuses, setTaskStatuses] = useState([]);
    const tstatuses = useSelector((state) => [...state.constants.data.taskStatuses])
        .filter(t => t.code != 'COMP')
        .sort((a, b) => a.code.toLowerCase().localeCompare(b.code.toLowerCase()));
    const pstatuses = useSelector((state) => [...state.constants.data.resourceStatuses])
        .sort((a, b) => a.code.toLowerCase().localeCompare(b.code.toLowerCase()));

    useEffect(() => {
        setTaskStatuses(tstatuses);
        setPatrolStatuses(pstatuses);
    }, []);

    const handleChange = (key) => (event) => {
        const raw = event.target.value == '' ? undefined : event.target.value;
        const isString = ['tasks.vehicleRegistrationNumber', 'patrols.fullName', 'patrols.callsign'].includes(key);


        const value = raw === 'all'
            ? undefined
            : isString
                ? raw
                : Array.isArray(event.target.value)
                    ? event.target.value
                    : Number(event.target.value);

        setFilters(prev => setDeepValue(prev, key.split('.'), value));
    }
    return (
        <>
            <Stack direction="row" spacing={2}>
                <FormControl fullWidth sx={{ minWidth: 190 }}>
                    <InputLabel>Resource</InputLabel>
                    <Select
                        multiple
                        name="resource"
                        onChange={handleChange('mixed.resource')}
                        value={filters.mixed.resource ?? 'all'}
                    >
                        <MenuItem value={0}>RSS Resource + Tasks</MenuItem>
                        <MenuItem value={1}>RECY Resource + Tasks</MenuItem>
                        <MenuItem value={2}>Tasks assigned to a garage</MenuItem>
                        <MenuItem value={3}>Unassigned Tasks</MenuItem>
                    </Select>
                </FormControl>
                <FormControl fullWidth sx={{ minWidth: 190 }}>
                    <InputLabel>Requires intervention?</InputLabel>
                    <Select
                        name="requiresIntervention"
                        onChange={handleChange('tasks.requiresIntervention')}
                        value={filters.tasks.requiresIntervention ?? 'all'}
                    >
                        <MenuItem value={1}>Yes</MenuItem>
                        <MenuItem value={0}>No</MenuItem>
                        <MenuItem value='all'>All</MenuItem>
                    </Select>
                </FormControl>
                {/* <FormControl fullWidth sx={{ minWidth: 190 }}>
                    <InputLabel>Home Start?</InputLabel>
                    <Select
                        name="isHomestart"
                        onChange={handleChange('tasks.isHomestart')}
                        value={filters.tasks.isHomestart ?? 'all'}
                    >
                        <MenuItem value={1}>Yes</MenuItem>
                        <MenuItem value={0}>No</MenuItem>
                        <MenuItem value='all'>All</MenuItem>
                    </Select>
                </FormControl> */}
                <FormControl fullWidth margin="normal">
                    <InputLabel>Task Status</InputLabel>
                    <Select multiple name="statusId" value={filters.tasks.statusId} onChange={handleChange('tasks.statusId')}>

                        {taskStatuses?.map((type, index) => <MenuItem key={index} value={type.id}>{type.code}</MenuItem>)}

                    </Select>
                </FormControl>
                <FormControl fullWidth margin="normal">
                    <InputLabel>Patrol Status</InputLabel>
                    <Select multiple name="status" value={filters.patrols.status} onChange={handleChange('patrols.status')}>
                        <MenuItem key={'na'} value={'N/A'}>None</MenuItem>
                        {patrolStatuses?.filter(s => s.id != 5).map((type, index) => <MenuItem key={index} value={type.id}>{type.code}</MenuItem>)}

                    </Select>
                </FormControl>
                <TextField
                    fullWidth
                    margin="normal"
                    label="Task Reg #"
                    name="vehicleRegistrationNumber"
                    value={filters.tasks.vehicleRegistrationNumber}
                    onChange={handleChange('tasks.vehicleRegistrationNumber')}
                />
                <TextField
                    fullWidth
                    margin="normal"
                    label="Patrol Full Name"
                    name="fullName"
                    value={filters.patrols.fullName}
                    onChange={handleChange('patrols.fullName')}
                />
                <TextField
                    fullWidth
                    margin="normal"
                    label="Patrol CallSign"
                    name="callsign"
                    value={filters.patrols.callsign}
                    onChange={handleChange('patrols.callsign')}
                />
            </Stack>
        </>
    );
}

export default MapFilters;